import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

const Modal = ({ show, onClose, children, hasCloseBtn = false }) => {
  const [isBrowser, setIsBrowser] = useState(false);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  const closeModalHandler = (e) => {
    e.preventDefault();
    document.body.classList.remove("no-scroll");
    onClose();
  };

  const modalContent = show ? (
    <>
      <div className="modal--container container fx fx--cv fx--ch">
        <div className="modal--overlay" onClick={closeModalHandler}></div>
        <div className="modal--body ps-r">
          {children}
          {hasCloseBtn && (
            <button onClick={closeModalHandler} className="modal__close">
              <em className="modal__close--btn"></em>
            </button>
          )}
        </div>
      </div>
    </>
  ) : null;

  if (isBrowser) {
    return ReactDOM.createPortal(
      modalContent,
      document.getElementById("modal-root")
    );
  } else {
    return null;
  }
};

export default Modal;
